//
//
//
//
//
//
//
//
//
//
//
//

import ProgressBar from "@Shared/components/general/progress-bar";
import { map } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationStatusProgressBar",
  components: {
    ProgressBar
  },
  props: {
    currentApplicationStatus: {
      type: String,
      required: true
    }
  },
  computed: {
    applicationStatuses() {
      return map(this.STATUS_MAP, key => ({
        id: key,
        value: this.$t("application.status")[key],
        selected: this.currentApplicationStatus === key
      }));
    }
  },
  created() {
    this.STATUS_MAP = ["pending", "submitted", "in-review", "completed"];
  }
});